var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "flex-grow-1", attrs: { fluid: "" } },
        [
          _c("v-row", { staticClass: "d-flex" }, [
            _c("p", [_vm._v(_vm._s(_vm.instructions))]),
          ]),
          _c(
            "v-row",
            { staticClass: "d-flex align-center" },
            [
              _c("PhotoLoad", {
                ref: "photoLoader",
                staticClass: "flex-grow-0",
                attrs: { "max-width": 1200, "max-height": 1200 },
                on: { "image-loaded": _vm.onImageLoaded },
              }),
              _vm.isLoading || _vm.isEstimating
                ? _c("v-progress-circular", {
                    staticClass: "ml-4",
                    attrs: { color: "primary", indeterminate: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }